import Service from './service';
import { AxiosResponse } from 'axios';
const Config = require('Config');

class CompanyService extends Service {
  constructor() {
    super(Config.companyServiceUrl);
  }

  async getCompany(email: string): Promise<any> {
    const response: AxiosResponse = await this.axios.get(`/${email}`);
    if (!response || response.status < 200 || response.status > 300 ) {
      throw new Error();
    }
    return response.data;
  }
};

export const companyService = new CompanyService();
